import React from 'react'
import { useMsal } from '@azure/msal-react'
import { Divider, Menu, MenuItem } from '@material-ui/core'
import CreateIcon from '@material-ui/icons/Create'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import ListIcon from '@material-ui/icons/List'
import ListAltIcon from '@material-ui/icons/ListAlt'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart'
import SettingsIcon from '@material-ui/icons/Settings'
import NotificationsIcon from '@material-ui/icons/Notifications'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import { useOverlayPreloader } from '../../../../../hooks/use-overlay-preloader'
import { useMyAccountMenu } from './my-account-menu.hook'
import { useMyAccountMenuStyles } from './my-account-menu.styles'

export type MyAccountMenuProps = {
  anchorEl: null | HTMLElement
  setAnchorEl: (anchorEl: null | HTMLElement) => void
}

export const MyAccountMenu: React.FC<MyAccountMenuProps> = (
  props
): React.ReactElement => {
  const classes = useMyAccountMenuStyles()
  const { anchorEl } = props
  const { menuClickHandler } = useMyAccountMenu(props)
  const { setIsShowOverlayPreloader } = useOverlayPreloader()
  const { t } = useTranslation()
  const { instance } = useMsal()

  /**
   * Handles user logout by showing preloader and redirecting to logout
   */
  const handleLogoutRedirect = () => {
    setIsShowOverlayPreloader(true)
    instance.logoutRedirect()
  }

  return (
    <Menu
      className={classes.root}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      id="my-account-header-menu"
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={menuClickHandler}
    >
      <MenuItem onClick={menuClickHandler}>
        <span className={classes.iconHolder}>
          <NotificationsIcon fontSize="small" />
        </span>
        <NavLink to="/notifications">{t('header.menu.notifications')}</NavLink>
      </MenuItem>
      <MenuItem onClick={menuClickHandler}>
        <span className={classes.iconHolder}>
          <SettingsIcon fontSize="small" />
        </span>
        <NavLink to="/account">{t('header.menu.settings')}</NavLink>
      </MenuItem>
      <MenuItem onClick={menuClickHandler}>
        <span className={classes.iconHolder}>
          <ListIcon fontSize="small" />
        </span>
        <NavLink to="/my-listed-items">
          {t('header.menu.myListedItems')}
        </NavLink>
      </MenuItem>
      <MenuItem onClick={menuClickHandler}>
        <span className={classes.iconHolder}>
          <ListAltIcon fontSize="small" />
        </span>
        <NavLink to="/listed-items/buyer">
          {t('header.menu.purchasedItems')}
        </NavLink>
      </MenuItem>
      <MenuItem onClick={menuClickHandler}>
        <span className={classes.iconHolder}>
          <ShoppingCartIcon fontSize="small" />
        </span>
        <NavLink to="/orders">{t('header.menu.myOrders')}</NavLink>
      </MenuItem>
      <MenuItem onClick={menuClickHandler}>
        <span className={classes.iconHolder}>
          <CreateIcon fontSize="small" />
        </span>
        <NavLink to="/draft-items">{t('header.menu.draftItems')}</NavLink>
      </MenuItem>
      <Divider />
      <MenuItem
        onClick={handleLogoutRedirect}
        className={classes.logoutMenuItem}
      >
        <span className={classes.iconHolder}>
          <ExitToAppIcon fontSize="small" />
        </span>
        <span className={classes.logoutText}>{t('header.menu.logout')}</span>
      </MenuItem>
    </Menu>
  )
}
